import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  root: {
    display: "inline",
    wordWrap: "break-word",
    whiteSpace: "normal"
  }
});
